var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note-component bordered-box"},[_c('div',{staticClass:"note-component__row row-textarea"},[_c('textarea',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }